<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" />
    </keep-alive>
    <Popup />
  </div>
</template>

<script>
import { methods } from "babel-plugin-transform-runtime/lib/definitions";
import "vant/lib/index.css";
import Popup from "./components/popup/Popup";

export default {
  name: "App",
  components: {
    Popup,
  },
  methods: {
    test() {
      // this.$http.post("http://localhost:8080");
    },
  },
  mounted() {
    console.log("====", this.$route.meta);
  },
};
</script>

<style lang="less">
@import "./assets/less/common.less";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue